import React, { useEffect, useState } from 'react';
import { Table, Button, Drawer, Space, Popconfirm, Card, Typography, Tag, Form, Switch, Input, Tooltip } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons';
import useMessage from 'antd/es/message/useMessage';
import dayjs from 'dayjs';
import CreateUser from '../../../components/Manage/Users/CreateUser';
import { EnquiryService } from '../../../Services/Manage/EnquiryService';
import { UserService } from '../../../Services/Manage/UserService';
import { GeneralService } from '../../../Services/General/GeneralService';
import { DepartmentEmpServices } from '../../../Services/Manage/DepartmentEmpServices';

const getPermission = (link) => {
  try {
    const raw = localStorage.getItem("ome_permission");
    const parsed = JSON.parse(raw);
    const permissions = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
    return permissions.find(p => p.link === link) || { add: false, edit: false, delete: false, read: false };
  } catch { return { add: false, edit: false, delete: false, read: false }; }
};

const UserManage = () => {

  const perm = getPermission('/manage-employees');
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [apiMessage, msgContext] = useMessage();
  const [generatedEQNo, setGeneratedEQNo] = useState('');
  const [form] = Form.useForm();
  const { Title } = Typography;

  const getAllServices = async () => {
    try {
      const request = await UserService.getAllUsers();
      const formattedData = request.data.map((item, index) => ({
        ...item,
        si_no: index + 1,
        key: item.id,
      }));
      setData(formattedData);
      setFilteredData(formattedData); // Initialize filtered data
    } catch (error) {
      console.error(error);
    }
  };

  const [deptList, setDeptList] = useState([]);

const getAllDepts = async () => {
    try {
        const res = await DepartmentEmpServices.getAllDepartment();
        setDeptList(res.data || []);
    } catch (e) { console.error(e); }
};

useEffect(() => {
    getAllServices();
    getAllDepts();
}, []);
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);
    const filtered = data.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && typeof val === 'string' && val.toLowerCase().includes(value)
      )
    );
    setFilteredData(filtered);
  };


  const handleAdd = () => {
    setEditingRecord(null);
    setDrawerOpen(true);
  };

  const handleEdit = (record) => {
    const editedRecord = {
      ...record,
      eq_no: record.user_id,
      n_follow_up: record.n_follow_up ? dayjs(record.n_follow_up, 'DD-MM-YYYY') : null,
    };
    setEditingRecord(editedRecord);
    setDrawerOpen(true);
  };

  const handleSubmit = async (values) => {
    const user = await UserService.getOmeUser();
    console.log(user)
    const payload = { ...values, uid: generatedEQNo || editingRecord.user_id, added_by: user.uid };

    if (editingRecord) {
      const request = await UserService.updateUsers(payload, editingRecord.user_id);
      if (request.status) {
        apiMessage.success(request.message);
        getAllServices();
      } else {
        apiMessage.error(request.message);
      }
    } else {
      const request = await UserService.createUsers(payload);
      if (request.status) {
        apiMessage.success(request.message);
        getAllServices();
      } else {
        apiMessage.error(request.message);
      }
    }
    setDrawerOpen(false);
  };

  const handleDelete = async (values) => {
    try {
      const req = await UserService.deleteUsers(values.uid);
      if (req.status) {
        apiMessage.success(req.message);
        getAllServices();
      } else {
        apiMessage.error(req.message);
        getAllServices();
      }
    } catch (error) {
      console.error(error);
      apiMessage.error('Failed to delete enquiry');
    }
  };

  const columns = [
    { title: 'S. No', dataIndex: 'si_no', key: 'si_no', align: 'center' },
    { title: 'UID', dataIndex: 'user_id', key: 'user_id' },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Role', dataIndex: 'role', key: 'role' },
{
    title: 'Department',
    key: 'department_name',
    render: (_, record) => {
        const ids = (record.department_id || "").split(",").map(s => s.trim());
        const names = deptList.filter(d => ids.includes(String(d.id))).map(d => d.name).join(", ");
        return names || "-";
    }
},
    { title: 'Email', dataIndex: 'email', key: 'email' },
    { title: 'Phone', dataIndex: 'phone', key: 'phone' },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag style={{ fontSize: '16px', padding: '6px 12px' }} color={status === 'Active' ? 'green' : 'red'}>
          {status}
        </Tag>
      ),
    },
 {
      title: 'Added On',
      dataIndex: 'added_on',
      key: 'added_on',
      render: (value) => value ? dayjs(value).format('DD-MM-YYYY hh:mm A') : '-',
    },
    {
      title: 'Actions',
      fixed: 'right',
      key: 'actions',
render: (_, record) => (
        <Space>
          <Tooltip title={!perm.edit ? "You don't have permission to edit" : ""}>
            <Button size="large" icon={<EditOutlined />} onClick={() => handleEdit(record)} disabled={!perm.edit} />
          </Tooltip>
          <Popconfirm title="Are you sure to delete?" onConfirm={() => handleDelete(record)}>
            <Button disabled size="large" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Card
      title="Manage Employees"
      extra={
        <Space>
          <Input
            size='large'
            placeholder="Search..."
            prefix={<SearchOutlined />}
            value={searchText}
            onChange={handleSearch}
            style={{ width: 300 }}
            allowClear
          />
   <Tooltip title={!perm.add ? "You don't have permission to create" : ""}>
            <Button size="large" type="primary" icon={<PlusOutlined />} onClick={handleAdd} disabled={!perm.add}>
              Add Employees
            </Button>
          </Tooltip>
        </Space>
      }
    >
      <Table columns={columns} dataSource={filteredData} pagination={true} scroll={{ x: 'max-content' }} />
      {msgContext}
      <Drawer
        title={
          <Space align="center">
            <Title level={4} style={{ margin: 0 }}>
              {editingRecord ? 'Edit Employees' : 'Add Employees'}{' '}
              {editingRecord ? (
                <>
                
                 <Tag
                      color="cyan"
                      style={{
                        fontSize: '16px',
                        padding: '6px 16px',
                        borderRadius: '8px',
                        fontWeight: 600,
                      }}
                    >
                      UID: {editingRecord.user_id}
                    </Tag>
                    
                    </>
              ) : (
                <>
                  {generatedEQNo && (
                    <Tag
                      color="blue"
                      style={{
                        fontSize: '16px',
                        padding: '6px 16px',
                        borderRadius: '8px',
                        fontWeight: 600,
                      }}
                    >
                      UID: {generatedEQNo}
                    </Tag>
                  )}
                </>
              )}{' '}
            </Title>
          </Space>
        }
        width={1000}
        open={drawerOpen}
        onClose={() => {
          setDrawerOpen(false);
          form.resetFields();
        }}
        destroyOnClose
        extra={
          <Form form={form} layout="inline">
            <Form.Item name="status" valuePropName="checked">
              <Switch checkedChildren="Active" unCheckedChildren="Inactive" style={{ transform: 'scale(1.2)' }} />
            </Form.Item>
          </Form>
        }
      >
        <CreateUser
          initialValues={editingRecord}
          onSubmit={handleSubmit}
          onCancel={() => setDrawerOpen(false)}
          handleEQNo={setGeneratedEQNo}
          form={form}
        />
      </Drawer>
    </Card>
  );
};

export default UserManage;